// extracted by mini-css-extract-plugin
module.exports = {"paper":"a4-1of1-qr-30x30_paper__1D2PN","page":"a4-1of1-qr-30x30_page__3Qg3B","container_qr_code":"a4-1of1-qr-30x30_container_qr_code__CfHzD"};